var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boxshell"},[_c('van-loading',{attrs:{"size":"48px","text-size":"24px"}},[_vm._v("加载中...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }